import { ChatListItem, ChatToggleData } from '@choco-admin/types';
import React from 'react';

import { ChatsTable } from './ChatsTable';
import { Pagination } from './Pagination';

interface ChatListContentProps {
  chats: ChatListItem[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  onChatToggle: (data: ChatToggleData) => void;
  onNextPageClick: () => void;
  onPreviousPageClick: () => void;
}

export const ChatListContent: React.FC<ChatListContentProps> = ({
  chats,
  isLoading,
  currentPage,
  totalPages,
  onChatToggle,
  onNextPageClick,
  onPreviousPageClick,
}) => {
  return (
    <div className="space-y-6">
      <ChatsTable
        chats={chats}
        onChatToggle={onChatToggle}
        isLoading={isLoading}
      />

      {!isLoading && chats.length > 0 && (
        <Pagination
          currentPage={currentPage}
          onNextPageClick={onNextPageClick}
          onPreviousPageClick={onPreviousPageClick}
          totalPages={totalPages}
        />
      )}
    </div>
  );
};
